/* Carrito Mercuryal (1-nov-2026) — adaptación del carrito de Jellymoon al cajón de Dawn.
   Fuente: /root/clientes/mercuryal/web/tema/carrito/mcx-carrito.js (lo sube build_carrito.py).
   - window.mcxCarrito.abrir(): repinta el cajón con el carrito actual y lo abre (lo usa la ficha mcx-ficha al añadir).
   - «+1 par» (data-mcx-mas), «Cambiar» a pack (data-mcx-pack) y el club −20 % (data-mcx-club). */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KL_COMPANY = 'UuMfBf';      // clave pública de la cuenta Klaviyo MERCURYAL
  var KL_LISTA = 'TH6Wkc';        // «Lista de correo electrónico» (la de los pop-ups y la bienvenida)
  var CLUB_CODE = 'BIENVENIDA20'; // código fijo de Shopify, el mismo de los pop-ups
  var ES = { rosa: 'pink', rojo: 'red', amarillo: 'yellow', azul: 'blue', gris: 'grey', morado: 'purple', naranja: 'orange', negro: 'black', blanco: 'white' };

  function drawer() { return document.querySelector('cart-drawer'); }
  function enPaginaCarrito() { return /\/cart\/?$/.test(location.pathname); }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  // Repinta el cajón y el icono con el carrito actual y lo abre. Sin cajón (o en /cart), recarga o va a /cart.
  function refrescar(desde) {
    var d = drawer();
    if (!d || (enPaginaCarrito() && !(desde && desde.closest && desde.closest('cart-drawer')))) {
      if (enPaginaCarrito()) location.reload(); else location.href = ROOT + 'cart';
      return Promise.resolve();
    }
    return Promise.all([
      fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }),
      fetch(ROOT + 'cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var s = res[0], c = res[1];
      d.classList.toggle('is-empty', c.item_count === 0);
      d.renderContents({ sections: s });
    });
  }
  window.mcxCarrito = { abrir: function () { return refrescar(null); }, refrescar: refrescar };

  function ocupado(el, on) { if (el) { el.disabled = on; el.classList.toggle('is-busy', on); } }
  function aviso(el, err) {
    var box = el.closest('.mcx-cart__tip,.mcx-cart__pack,.mcx-cart__club') || el.parentNode;
    var p = box.querySelector('.mcx-cart__msg');
    if (!p) { p = document.createElement('p'); p.className = 'mcx-cart__msg'; box.appendChild(p); }
    p.hidden = false; p.textContent = (err && (err.description || err.message)) || 'No se ha podido actualizar la cesta. Prueba otra vez.';
  }

  // Variante del pack: misma regla que la ficha (pkVar): talla exacta; color traducido; si no, «Basic» o la primera.
  function elegirVariante(prod, opts) {
    var vs = (prod.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return null;
    if (vs.length === 1) return vs[0];
    var s = opts.filter(Boolean).map(function (x) { x = x.toLowerCase(); return ES[x] || x; });
    var nombres = (prod.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    if (nombres.some(function (o) { return /talla|size/i.test(o); })) {
      return vs.filter(function (x) { return s.indexOf(x.title.toLowerCase()) >= 0; })[0] || 'talla';
    }
    var col = s.filter(function (x) { return x !== 'black' && x !== 'black basic'; })[0];
    var m = col ? vs.filter(function (x) { return x.title.toLowerCase().indexOf(col) >= 0; })[0] : vs.filter(function (x) { return /basic/i.test(x.title); })[0];
    return m || vs[0];
  }

  function cambiarAPack(btn) {
    var quitar = {}; // «clave=cantidad,clave=cantidad»: líneas que se quitan (o bajan) al pasar al pack
    (btn.dataset.quitar || '').split(',').forEach(function (x) { var i = x.lastIndexOf('='); if (i > 0) quitar[x.slice(0, i)] = +x.slice(i + 1) || 0; });
    var opts = (btn.dataset.opts || '').split('|');
    var h = btn.dataset.mcxPack;
    return fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var v = elegirVariante(prod, opts);
      if (v === 'talla') { location.href = ROOT + 'products/' + h; return; }
      if (!v) throw { description: 'Este pack está agotado.' };
      // primero se añade el pack y después se quitan las piezas sueltas: si algo falla, nunca se pierde nada de la cesta
      return post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
        .then(function () { return post('cart/update.js', { updates: quitar }); })
        .then(function () { return refrescar(btn); });
    });
  }

  // Club −20 %: solo para quien no tiene sesión (lo filtra el Liquid) y no se ha apuntado desde este navegador.
  try { if (!localStorage.getItem('mcx_club')) document.documentElement.classList.add('mcx-anon'); }
  catch (e) { document.documentElement.classList.add('mcx-anon'); }

  function club(box) {
    if (!box || box.dataset.enviando) return;
    var inp = box.querySelector('input[type=email]'), btn = box.querySelector('[data-mcx-club-btn]');
    var email = (inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { aviso(btn, { message: 'Escribe un email válido.' }); inp.focus(); return; }
    box.dataset.enviando = '1'; ocupado(btn, true);
    var m = box.querySelector('.mcx-cart__msg'); if (m) m.hidden = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Carrito · ' + (box.dataset.producto || ''),
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: KL_LISTA } } } } })
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      try { localStorage.setItem('mcx_club', '1'); } catch (e) {}
      if (window.klaviyo && window.klaviyo.identify) { try { window.klaviyo.identify({ email: email }); } catch (e) {} }
      return fetch(ROOT + 'discount/' + CLUB_CODE, { credentials: 'same-origin' }).catch(function () {});
    }).then(function () {
      document.documentElement.classList.remove('mcx-anon');
      return refrescar(box);
    }).catch(function () {
      delete box.dataset.enviando; ocupado(btn, false);
      aviso(btn, { message: 'No se ha podido apuntar. Prueba otra vez.' });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var b = t.closest('[data-mcx-mas]');
    if (b) {
      e.preventDefault(); ocupado(b, true);
      post('cart/add.js', { items: [{ id: +b.dataset.id, quantity: +b.dataset.n || 1 }] })
        .then(function () { return refrescar(b); })
        .catch(function (err) { ocupado(b, false); aviso(b, err); });
      return;
    }
    var p = t.closest('[data-mcx-pack]');
    if (p) {
      e.preventDefault(); ocupado(p, true);
      cambiarAPack(p).catch(function (err) { ocupado(p, false); aviso(p, err); });
      return;
    }
    var c = t.closest('[data-mcx-club-btn]');
    if (c) { e.preventDefault(); club(c.closest('[data-mcx-club]')); }
  });
  // Enter en el email = botón (y nunca envía el formulario del carrito)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var box = e.target.closest('[data-mcx-club]');
    if (box) { e.preventDefault(); club(box); }
  }, true);
  // El carrito de Dawn escucha «change» para las cantidades: lo de mcx-cart no debe llegarle
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.mcx-cart')) e.stopPropagation();
  }, true);
})();
